<template>
    <el-dialog
        class="set-private"
        :visible.sync="setCombineSkuVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Set Combination"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="setCombineForm"
                :model="setCombineForm"
                :rules="rules"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Select"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please select Type',
                                },
                            ]"
                            prop="type"
                            size="small"
                        >
                            <el-radio-group
                                v-model="setCombineForm.type"
                                @change="typeChange"
                            >
                                <el-radio :label="1">SPU</el-radio>
                                <el-radio :label="2">SKU</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="setCombineForm.type == '1'">
                        <el-form-item label="SPU" prop="content" size="small" 
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input SPU',
                                },
                            ]">
                            <el-input
                                type="textarea"
                                v-model="setCombineForm.content"
                                :autosize="{ minRows: 5, maxRows: 10 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="setCombineForm.type == '2'">
                        <el-form-item label="SKU" prop="content" size="small"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input SKU',
                                },
                            ]">
                            <el-input
                                type="textarea"
                                v-model="setCombineForm.content"
                                :autosize="{ minRows: 5, maxRows: 10 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label=" Combination SKU"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please select Combination SKU',
                                },
                            ]"
                            prop="is_combine_sku"
                            size="small"
                        >
                           <el-select
                            v-model="setCombineForm.is_combine_sku"
                            clearable
                            filterable
                            size="small"
                        >
                            <el-option
                                :label="item.label"
                                :value="item.value"
                                v-for="item of combineList"
                                :key="item.value"
                            ></el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="setCombineSkuVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            setCombineForm: {
                type: 1,
                content: "",
                is_combine_sku:""
            },
            rules: {},
            combineList:[
                {
                    label: "Yes",
                    value: 1,
                },
                {
                    label: "No",
                    value: 2,
                },
            ],
        };
    },
    methods: {

        closeDialog() {
            this.userList = [];
            this.$refs["setCombineForm"].clearValidate();
            this.$refs["setCombineForm"].resetFields();
            this.$emit("update:setCombineSkuVisible", false);
        },
        save() {
            this.$refs["setCombineForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .setCombineSku(
                            {
                                type: this.setCombineForm.type,
                                content: this.setCombineForm.content.split("\n"),
                                is_combine_sku: this.setCombineForm.is_combine_sku
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                if(res.errmsg != 'ok'){
                                    this.$message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: res.errmsg,
                                        showClose: true,
                                        duration: 3000
                                    });
                                }else{
                                    this.$message.success("Success!");
                                    this.closeDialog();
                                } 
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            })
            
        },
    },
    props: {
        setCombineSkuVisible: Boolean,
    },
    watch: {
        setCombineSkuVisible(val) {},
    },
};
</script>
<style lang="scss" scoped>
.set-private {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
